'use client';

import { signUpAction } from '@/app/actions';
import { FormMessage, type Message } from '@/components/form-message';
import OneTapComponent from '@/components/one-tap-component';
import { Signup1 } from '@/components/signup1';
import { createClient } from '@/utils/supabase/client';
import { useEffect, useState } from 'react';
import { SmtpMessage } from '../smtp-message';

const defaultLogo = {
  url: 'https://www.shadcnblocks.com',
  src: 'https://shadcnblocks.com/images/block/block-1.svg',
  alt: 'logo',
  title: 'shadcnblocks.com',
};

export default function Signup(props: { searchParams: Promise<Message> }) {
  const [message, setMessage] = useState<Message | null>(null);
  const [loading, setLoading] = useState(false);
  const supabase = createClient();

  useEffect(() => {
    props.searchParams.then((msg) => {
      if (msg) setMessage(msg);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGoogleSignUp = async () => {
    await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        redirectTo: `${window.location.origin}/auth/callback`,
      },
    });
  };

  async function handleSubmit(formData: FormData) {
    setLoading(true);
    const result = await signUpAction(formData);
    if (
      result &&
      typeof result === 'object' &&
      ('success' in result || 'error' in result || 'message' in result)
    ) {
      setMessage(result as Message);
    }
    setLoading(false);
  }

  return (
    <div className="flex flex-col items-center justify-center min-h-screen w-full">
      <OneTapComponent />
      {message && 'message' in message ? (
        <div className="w-full flex-1 flex items-center h-screen sm:max-w-md justify-center gap-2 p-4">
          <FormMessage message={message} />
        </div>
      ) : (
        <form action={handleSubmit} className="w-full max-w-md">
          <Signup1
            heading="Sign up"
            subheading="Create a new account"
            logo={defaultLogo}
            signupText="Sign up"
            googleText="Sign up with Google"
            loginText="Already have an account?"
            loginUrl="/sign-in"
            onGoogleSignUp={handleGoogleSignUp}
          />
          {message && <FormMessage message={message} />}
        </form>
      )}
      <SmtpMessage />
    </div>
  );
}
